"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countEnemies = exports.updateTick = exports.update = exports.create = exports.EAlienAi = void 0;
var diveAi_master_sidecar_1 = require("@dive/ai/diveAi_master-sidecar");
var diveSimulationManager_sidecar_1 = require("@dive/simulation/diveSimulationManager-sidecar");
var diveTilemapUtils_sidecar_1 = require("@dive/tilemap/diveTilemapUtils-sidecar");
var assert_sidecar_1 = require("@lib/assert-sidecar");
var imports_1 = require("@lib/imports");
var rando_sidecar_1 = require("@lib/rando-sidecar");
var common_sidecar_1 = require("@main/common-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var spritesCrew_1 = require("../dive/spriteRecyclers/spritesCrew");
var diveCrew_enemy_data_sidecar_1 = require("./diveCrew_enemy_data-sidecar");
var diveCrew_misc_sidecar_1 = require("./diveCrew_misc-sidecar");
var diveCrew_movable_sidecar_1 = require("./diveCrew_movable-sidecar");
var diveCrew_weaponData_1 = require("./diveCrew_weaponData");
var diveCrew_hero_data_1 = require("./diveCrew_hero_data");
var diveParticles_sidecar_1 = require("@dive/effects/diveParticles-sidecar");
var diveColors_1 = require("@dive/colors/diveColors");
var diveFont_sidecar_1 = require("@dive/fonts/diveFont-sidecar");
var voyageCamera_sidecar_1 = require("@voyage/camera/voyageCamera-sidecar");
var EAlienAi;
(function (EAlienAi) {
    EAlienAi[EAlienAi["Guard"] = 1] = "Guard";
    EAlienAi[EAlienAi["Goto"] = 2] = "Goto";
    EAlienAi[EAlienAi["Bomb"] = 3] = "Bomb";
})(EAlienAi = exports.EAlienAi || (exports.EAlienAi = {}));
function create(type) {
    var data = diveCrew_enemy_data_sidecar_1.diveCrew_enemy_data.find(type);
    assert_sidecar_1.assert.notNil(data);
    var d = {
        // enemyType: type,
        data: data,
        // fireExtinguishTimer: 0,
        // useSystemTimer: 0,
        isAiInitiated: false,
        // aiType: EAlienAi.Bomb,
        aiType: rando_sidecar_1.rando.sample([EAlienAi.Guard, EAlienAi.Bomb, EAlienAi.Goto]),
        abilityTimerTicks: 0,
    };
    return d;
}
exports.create = create;
function update(obj) {
    var _a;
    var ds = common_sidecar_1.common.getUpdateDeltaScaled();
    var d = obj.enemyState;
    assert_sidecar_1.assert.notNil(d);
    if (obj.isDead) {
        return;
    }
    if (obj.isDying) {
        diveCrew_sidecar_1.diveCrew.kill(obj);
        return;
    }
    diveCrew_movable_sidecar_1.diveCrew_movable.update(obj);
    var data = (_a = obj.enemyState) === null || _a === void 0 ? void 0 : _a.data;
    assert_sidecar_1.assert.notNil(data);
    // TODO: different monster types
    var frames = data.frames; //[sprites.diveMonsters10C8[0], sprites.diveMonsters11C9[0]]
    var bounceIdx = diveSimulationManager_sidecar_1.diveSimulationManager.get2frameIdx();
    var frame = frames.idle[bounceIdx % frames.idle.length];
    var visibility = diveTilemapUtils_sidecar_1.diveTilemapUtils.getSpotVisiblityIIJ(obj);
    if (visibility === 0) {
        return;
    }
    // TODO: add was-seen ghosts?
    if (visibility === 1) {
        return;
    }
    var isDead = obj.hitpoints <= 0;
    var imgShadow = diveCrew_misc_sidecar_1.diveCrew_misc.renderShadow(obj, d.data.renderShadow);
    // Dead!
    if (isDead) {
        frame = frames.dead[0]; //sprites.diveMonsters12C10[0]
    }
    if (!isDead) {
        // Add attacking frame
        var wd = obj.weaponState;
        if (wd) {
            if (wd.state === diveCrew_weaponData_1.EDiveWeaponState.PreAttack1) {
                frame = frames.attackR[0];
            }
            if (wd.state === diveCrew_weaponData_1.EDiveWeaponState.PreAttack2) {
                frame = frames.attackR[1];
            }
            if (wd.state === diveCrew_weaponData_1.EDiveWeaponState.PostAttack) {
                frame = frames.attackR[2] || frames.attackR[0];
            }
            if (wd.state === diveCrew_weaponData_1.EDiveWeaponState.Reloading) {
                frame = frames.idle[0]; // TODO: reloading frame?
            }
        }
    }
    // Render for dive
    var img = spritesCrew_1.spritesCrew.getNext(obj.x, obj.y, frame);
    img.scaleX = obj.isFlipped ? -img.scaleX : img.scaleX;
    if (data.scale !== 1) {
        img.scaleX *= data.scale;
        img.scaleY *= data.scale;
        if (imgShadow) {
            imgShadow.scaleX *= data.scale;
            imgShadow.scaleY *= data.scale;
        }
    }
    if (data.letter) {
        diveFont_sidecar_1.diveFont.writeAbsolute(voyageCamera_sidecar_1.voyageCamera.applyCamX(obj.x), voyageCamera_sidecar_1.voyageCamera.applyCamY(obj.y - 10), data.letter);
    }
    if (obj.pathResult) {
        // Still moving
        return;
    }
    // voyageGameStatus.get().hasBoarders.willBeActive = true
    // if (!d.isAiInitiated) {
    //   if (voyageWebsockets.getIsHost()) {
    //     if (d.aiType === EAlienAi.Guard) {
    //       d.isAiInitiated = true
    //     }
    //     if (d.aiType === EAlienAi.Goto) {
    //       // TODO: add this in?
    //       // let f = voyageTilemap.getRandomFloor()
    //       // if (voyageCrew_movable.requestPathTo(obj, f.i, f.j)) {
    //       //   d.isAiInitiated = true
    //       // }
    //     }
    //     if (d.aiType === EAlienAi.Bomb) {
    //       if (obj.items.length === 0) {
    //         voyageMessageCrewCarry.sendCreateMessageAndImmediatelyExecute({
    //           type: rando.sample([
    //             EVoyageCarryableType.Breachbomb,
    //             EVoyageCarryableType.Firebomb,
    //           ]),
    //           i: obj.i,
    //           j: obj.j,
    //           crewId: obj.id,
    //         })
    //       }
    //       let f = voyageTilemap.getRandomFloor()
    //       // TODO: fix this?
    //       // if (voyageCrew_movable.requestPathTo(obj, f.i, f.j)) {
    //       //   d.isAiInitiated = true
    //       // }
    //     }
    //   }
    // } else {
    //   if (d.aiType === EAlienAi.Bomb) {
    //     if (!obj.path && obj.items.length > 0) {
    //       voyageMessageCrewCarry.sendMessageAndImmediatelyExecute({
    //         command: EVoyageCrewCarryCommand.Drop,
    //         carryId1: obj.items[0].id,
    //         carryId2: 0,
    //         crewId: obj.id,
    //         i: obj.i,
    //         j: obj.j,
    //         type: obj.items[0].type,
    //       })
    //     }
    //     if (obj.items.length === 0) {
    //       voyageMessageCrewHurt.sendMessageAndImmediatelyExecute({
    //         crewId: obj.id,
    //         byCrewId: 0,
    //         newHitpoints: 0,
    //         type: EVoyageCrewDamageType.Teleport,
    //       })
    //     }
    //   }
    // }
}
exports.update = update;
function updateTick(obj) {
    diveCrew_movable_sidecar_1.diveCrew_movable.updateTick(obj);
    diveAi_master_sidecar_1.diveAi_master.updateTick(obj);
    if (diveCrew_sidecar_1.diveCrew.isDeadish(obj)) {
        return;
    }
    if (diveCrew_sidecar_1.diveCrew.isUnableToAct(obj)) {
        return;
    }
    var tile = obj.tile;
    if (tile) {
        if (!obj.isAwake) {
            if (diveTilemapUtils_sidecar_1.diveTilemapUtils.wasSpotVisibleToHero(tile)) {
                obj.isAwake = true; // TODO: make a function?
            }
        }
        if (obj.isAwake) {
            obj.ticksAwake++;
            if (obj.enemyState) {
                if (obj.enemyState.data.transformInto) {
                    if (obj.ticksAwake >= obj.enemyState.data.transformTicksTime) {
                        diveCrew_sidecar_1.diveCrew.kill(obj);
                        var mons = diveCrew_sidecar_1.diveCrew.create(diveCrew_1.EVoyageCrewType.Enemy, diveCrew_hero_data_1.EDiveHeroSubtype.None, obj.enemyState.data.transformInto, 0, 0);
                        diveCrew_sidecar_1.diveCrew.moveToIIJ(mons, tile);
                        if (diveTilemapUtils_sidecar_1.diveTilemapUtils.isSpotVisibleToHero(tile)) {
                            diveParticles_sidecar_1.diveParticles.createMultiple('poof', mons.x, mons.y, 10, diveColors_1.diveColors.pureWhite);
                        }
                    }
                }
            }
        }
    }
}
exports.updateTick = updateTick;
function countEnemies() {
    var num = 0;
    imports_1.l.forEach(diveCrew_sidecar_1.diveCrew.getAll(), function (c) {
        if (c.type === diveCrew_1.EVoyageCrewType.Enemy) {
            num++;
        }
    });
    return num;
}
exports.countEnemies = countEnemies;
